import React from "react";
import check from "../../Assets/img/Group 43340.svg";
import Illustration from "../../Assets/img/Rectangle 1491.svg";
import { Link } from "react-router-dom";

const RecruitmentSection = () => {
  const firstRowCards = [
    {
      title: "Tailored Search Strategies",
      text: "We develop customized recruitment plans for each role, leveraging a vast network and advanced search tools to identify the best candidates.",
      animation: "animate__fadeInLeft",
      ariaLabel: "Tailored Search Strategies",
    },
    {
      title: "Extensive Candidate Network",
      text: "Access our pre-qualified database of passive and active job seekers across various industries and specialties.",
      animation: "animate__fadeInUp",
      ariaLabel: "Extensive Candidate Network",
    },
    {
      title: "Rigorous Vetting Process",
      text: "Our in-depth screening includes competency-based interviews, skill assessments, and thorough background checks to ensure quality.",
      animation: "animate__fadeInRight",
      ariaLabel: "Rigorous Vetting Process",
    },
  ];

  const secondRowCards = [
    {
      title: "Time and Cost Efficiency",
      text: "We streamline the hiring process, saving you valuable time and reducing recruitment costs, allowing you to focus on your core business.",
      animation: "animate__fadeInLeft",
      ariaLabel: "Time and Cost Efficiency",
    },
    {
      title: "Expert Industry Knowledge",
      text: "Our recruiters specialize in various sectors, providing invaluable insights and understanding of specific industry demands.",
      animation: "animate__fadeInRight",
      ariaLabel: "Expert Industry Knowledge",
    },
  ];
  const Benefits = [
    {
      title: "Scalability",
      desc: "Easily scale your recruitment efforts up or down based on your business needs without increasing your internal HR overhead.",
    },
    {
      title: "Cost Reduction",
      desc: "Convert fixed recruitment costs into variable costs and achieve significant savings through optimized processes and reduced time-to-hire.",
    },
    {
      title: "Improved Candidate Quality",
      desc: "Access our specialized recruiters and advanced tools, leading to a higher caliber of candidates.",
    },
    {
      title: "Enhanced Employer Brand",
      desc: "Easily scale your recruitment efforts up or down based on your business needs without increasing your internal HR overhead.",
    },
    {
      title: "Compliance and Best Practices",
      desc: "Benefit from our expertise in recruitment best practices and ensure compliance with all relevant hiring regulations.",
    },
  ];
  return (
    <>
      <section className="service-1 Apply-padding" id="recruitment">
        <div className="container">
          {/* Header */}
          <div className="text-center mb-4 px-3 animate__animated animate__fadeInDown">
            <h2 className="section-title-service">
              <span className="highlight-number-service">01</span> Recruitment
            </h2>
            <p
              className="mt-3 fs-6 fw-normal mx-auto"
              style={{
                fontWeight: 500,
                fontSize: "16px",
                color: "#101011",
              }}
            >
              At Anaxistech, we understand that finding the right talent is
              critical to your business's success. Our comprehensive recruitment
              services are designed to connect you with top-tier candidates who
              not only possess the required skills and experience but also align
              with your company culture. We go beyond simply matching resumes;
              we delve deep to understand your specific needs, ensuring a
              perfect fit every time.
            </p>
            <h5 className="fw-bold mt-4 animate__animated animate__fadeInUp">
              Why Choose Anaxis for Recruitment?
            </h5>
          </div>

          {/* First row cards */}
          <div className="card-flex-row">
            {firstRowCards.map((card, index) => (
              <div
                className={`feature-card animate__animated ${card.animation}`}
                key={index}
                tabIndex={0}
                role="article"
                aria-label={card.ariaLabel}
              >
                <h3 className="feature-title-service">{card.title}</h3>
                <div className="d-flex align-items-start mb-2">
                  <div className="feature-underline"></div>
                  <p className="feature-text-service">{card.text}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Second row cards */}
          <div className="card-flex-row-sm mb-3">
            {secondRowCards.map((card, index) => (
              <div
                className={`feature-card animate__animated ${card.animation}`}
                key={index}
                tabIndex={0}
                role="article"
                aria-label={card.ariaLabel}
              >
                <h3 className="feature-title-service">{card.title}</h3>
                <div className="d-flex align-items-start mb-2">
                  <div className="feature-underline"></div>
                  <p className="feature-text-service">{card.text}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Explore Button */}
          <div className="text-center animate__animated animate__zoomIn">
            <Link to="/contact-us" className="text-decoration-none">
              <button type="button" className="explore-btn-services ">
                Explore More
              </button>
            </Link>
          </div>
        </div>
      </section>
      <section className="service-2 Apply-padding" id="recruitment-process-outsourcing">
        <div className="container">
          <div className="text-center mb-4">
            <h2>
              <span className="highlight-number">02</span> Recruitment Process
              Outsourcing
            </h2>
            <p className="intro-text mx-auto">
              Streamline and enhance your hiring efforts with Anaxistech's
              Recruitment Process Outsourcing (RPO) solutions. RPO allows you to
              outsource all or part of your recruitment functions to our expert
              team, transforming your hiring process into a more efficient,
              scalable, and cost-effective operation. From candidate sourcing
              and screening to interview coordination and offer management, we
              handle the complexities so you don’t have to.
            </p>
          </div>

          <div className="row align-items-center gy-4">
            <div className="col-lg-5 text-center">
              <div className="main-image-services">
                <img
                  src={Illustration}
                  alt="Illustration of recruitment tasks"
                  className="img-fluid"
                  style={{ width: "398px", height: "509px", marginTop: "20px" }}
                />
              </div>
              <Link to="/contact-us" className="text-decoration-none">
                <button className="explore-btn-home" type="button">
                  Explore More
                </button>
              </Link>
            </div>

            <div className="col-lg-6">
              <h3 className="benefits-title">Benefits of Anaxis RPO</h3>

              {Benefits.map((benefit, index) => (
                <div className="benefit-item d-flex" key={index}>
                  <div className="check-icon" aria-hidden="true">
                    <img src={check} alt="Check" />
                  </div>
                  <div className="main-serrvice-2">
                    <strong>{benefit.title}</strong>
                    <p>{benefit.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default RecruitmentSection;
